import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { FULFILLED } from '../../constants/constants'
import { setIsMobileMenuOpen, setIsSummaryPreviewExpanded } from '../../store/ui/uiSlice'
import ArticlesList from '../ArticlesList/ArticlesList'
import CloseButton from '../CloseButton/CloseButton'
import DeliveryInfo from '../DeliveryInfo/DeliveryInfo'
import PriceSummary from '../PriceSummary/PriceSummary'
import * as Styled from './styles'
import { useAppDispatch, useAppSelector } from '../../hooks'

const SummaryPreview: React.FC = () => {
  const dispatch = useAppDispatch()

  const { summary } = useAppSelector((state) => state.bundle)
  const { content } = useAppSelector((state) => state.init)
  const { isMobileMenuOpen, isSummaryPreviewExpanded } = useAppSelector((state) => state.ui)
  const { requestStatus_fetchPrices_aggregated } = useAppSelector((state) => state.requests.requestStatus)

  const hideDiscounts = import.meta.env.VITE_HIDE_DISCOUNTS === 'true'
  const bundleHasAnyDiscount = summary && summary.Price !== summary.OrdinaryPrice ? true : false

  return (
    <Styled.SummaryPreview bundleHasAnyDiscount={bundleHasAnyDiscount} isExpanded={isSummaryPreviewExpanded}>
      <Styled.CampaignAndPriceWrapper>
        {hideDiscounts ? null : requestStatus_fetchPrices_aggregated !== FULFILLED ? (
          <Skeleton width="65px" height="20px" borderRadius="25px" />
        ) : bundleHasAnyDiscount ? (
          <Styled.Campaignbubble>{content.other.campaign}</Styled.Campaignbubble>
        ) : null}
        <button
          className="expand-collapse-btn"
          onClick={() => {
            if (isMobileMenuOpen) dispatch(setIsMobileMenuOpen(false))
            dispatch(setIsSummaryPreviewExpanded(!isSummaryPreviewExpanded))
          }}
        >
          {requestStatus_fetchPrices_aggregated === FULFILLED ? (
            <span className={`price${summary?.Price > 99999 ? ' is-high-amount' : ''}`}>{summary?.FormatedPrice}</span>
          ) : (
            <Skeleton width="75px" height="22px" />
          )}
          <i className={`fas fa-chevron-${isSummaryPreviewExpanded ? 'up' : 'down'}`} aria-hidden="true" />
          <span className="screen-reader screen-reader-focusable">
            ${isSummaryPreviewExpanded ? content.other.showLess : content.other.showMore}
          </span>
        </button>
      </Styled.CampaignAndPriceWrapper>
      <div className="expanded-info-container">
        <CloseButton
          onClick={() => {
            dispatch(setIsSummaryPreviewExpanded(false))
          }}
          label={content.other.showLess}
        />
        <PriceSummary />
        {(!import.meta.env.VITE_HIDE_DELIVERY_INFO || import.meta.env.VITE_HIDE_DELIVERY_INFO === 'false') && (
          <DeliveryInfo />
        )}
        <ArticlesList />
      </div>
    </Styled.SummaryPreview>
  )
}

export default SummaryPreview
